export const ColourSwatchComponent = {
  name: 'quickshop-colour-swatches',
  template: `#quickshop-colour-swatches`,
  props: ['label', 'position', 'options', 'swatches', 'selectedValue'],
  methods: {
    setActiveSwatch: function (swatch) {
      // Here we want to target the hidden dropdown and change the value within
      let dataValue = swatch.name;

      // Update the selected colour label
      $('[data-selected-colour]').text(dataValue);

      // this.selectedValue = swatch.name;
      this.$emit('changeSelect', swatch.name);
    },
  },
  computed: {
    dropdown: {
      get() {
        return this.selectedValue;
      },
      set(val) {
        this.$emit('changeSelect', val);
      },
    },
  },
};
